import moment from 'moment'

export class gridHelper {
	static sortingComparator = (valueA: any, valueB: any) => {
		if (valueA == null) return -1
		if (valueB == null) return 1

		if (typeof valueA === 'string' && typeof valueB === 'string') {
			return valueA.localeCompare(valueB)
		}

		return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
	}

	static handleSortChanged(event: any): GridSortingDetails {
		const sortModel = event.api
			.getColumnState()
			.filter((s: any) => s.sort != null)
			.map((s: any) => ({
				colId: s.colId,
				sort: s.sort,
				sortIndex: s.sortIndex,
			}))

		if (sortModel.length === 0) {
			const empty: GridSortingDetails = {
				sortField: '',
				sortOrder: '',
			}
			return empty
		}

		const first = sortModel[0]

		const result: GridSortingDetails = {
			sortField: first.colId,
			sortOrder: first.sort,
		}

		return result
	}

	static expandAll = (params: any) => {
		params.api.expandAll()
	}

	static collapseAll = (params: any) => {
		params.api.collapseAll()
	}
}

export interface GridSortingDetails {
	sortField: string
	sortOrder: string
}

export interface GridPaginationResponse<T> {
	data: T[]
	currentPage: number
	totalPages: number
	totalCount: number
	pageSize: number
	hasPreviousPage: boolean
	hasNextPage: boolean
}

/** Client-side page + sort wrapper for APIs that return a full list. */
export function toPagedGridResponse<T>(
	items: T[],
	pageNumber: number,
	pageSize: number,
	sortField?: string,
	sortOrder?: string
): GridPaginationResponse<T> {
	let sorted = items
	if (sortField) {
		const dir = sortOrder?.toLowerCase() === 'asc' ? 1 : -1
		sorted = [...items].sort((a, b) => {
			const va = (a as Record<string, unknown>)[sortField]
			const vb = (b as Record<string, unknown>)[sortField]
			return gridHelper.sortingComparator(va, vb) * dir
		})
	}

	const size = Math.max(pageSize, 1)
	const totalCount = sorted.length
	const totalPages = Math.max(1, Math.ceil(totalCount / size) || 1)
	const page = Math.min(Math.max(1, pageNumber), totalPages)
	const start = (page - 1) * size

	return {
		data: sorted.slice(start, start + size),
		currentPage: page,
		pageSize: size,
		totalCount,
		totalPages,
		hasPreviousPage: page > 1,
		hasNextPage: page < totalPages,
	}
}

export const defaultGridColDef = {
	//resizable: false,
	flex: 1,
	suppressMovable: true,
	sortable: true,
	minWidth: 200,
	cellClass: 'no-cell-focus',
}

/** Shared column config for grid action button groups. */
export const gridActionsColumnDef = {
	sortable: false,
	cellClass: 'actions',
	headerClass: 'actions',
	minWidth: 160,
	maxWidth: 280,
	flex: 0,
	suppressSizeToFit: true,
} as const
